export default "__VITE_ASSET__DWuQnUxN__"